import IconInfo from './icon-info';

export default IconInfo;
